import Vue from 'vue'
import VueI18n from 'vue-i18n'

const AVAILABLE_LOCALES = [
    {
        locale: 'en',
        img: require('@/assets/images/flags/en.png'),
        name: 'English'
    },
    {
        locale: 'ko',
        img: require('@/assets/images/flags/ko.png'),
        name: '한국어'
    },
    {
        locale: 'ja',
        img: require('@/assets/images/flags/ja.png'),
        name: '日本語'
    }
]

Vue.use(VueI18n)

function detectLanguage () {
    try {
        const lang = localStorage.getItem('locale') ||
            (window.navigator.languages && window.navigator.languages[0]) ||
            window.navigator.language ||
            window.navigator.userLanguage
        return lang.toLowerCase().substr(0, 2)
    } catch (e) {
        return undefined
    }
}

function loadLocaleMessages () {
    const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i)
    const messages = {}
    locales.keys().forEach(key => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            messages[locale] = locales(key)
        }
    })
    return messages
}

function getInstalledLocale () {
    const lang = detectLanguage()
    return AVAILABLE_LOCALES.map(locale => locale.locale).includes(lang) ? lang : undefined
}

function autoInstallLocale () {
    const lang = getInstalledLocale() || process.env.VUE_APP_I18N_LOCALE
    AVAILABLE_LOCALES.map(locale => locale.locale).includes(lang) && localStorage.setItem('locale', lang)
}

autoInstallLocale()

export {
    AVAILABLE_LOCALES
}

export default new VueI18n({
    locale: getInstalledLocale() || process.env.VUE_APP_I18N_LOCALE,
    fallbackLocale: getInstalledLocale() || process.env.VUE_APP_I18N_FALLBACK_LOCALE,
    messages: loadLocaleMessages()
})
